import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  additionalInfo: {
    color: palette.shades[700]
  },
  loaderWrapper: {
    marginTop: '180px',
    textAlign: 'center'
  },
  successBlockWrapper: {
    marginTop: '48px',
    textAlign: 'center'
  }
});
export default useStyles;